export default {
  name: 'misc.situation',
  key: 'situation',
  attributes: {
    life: {
      key: 'life',
      name: 'entity.asteroidBase.situation.life',
    },
    asteroid: {
      key: 'asteroid',
      name: 'entity.asteroidBase.situation.asteroid',
    },
    nasty: {
      key: 'nasty',
      name: 'entity.asteroidBase.situation.nasty',
    },
    fighting: {
      key: 'fighting',
      name: 'entity.asteroidBase.situation.fighting',
    },
    priceless: {
      key: 'priceless',
      name: 'entity.asteroidBase.situation.priceless',
    },
  },
};
